import { render, staticRenderFns } from "./Identity.vue?vue&type=template&id=5aa112b4&scoped=true"
import script from "./Identity.vue?vue&type=script&lang=js"
export * from "./Identity.vue?vue&type=script&lang=js"
import style0 from "./Identity.vue?vue&type=style&index=0&id=5aa112b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa112b4",
  null
  
)

export default component.exports